import React from "react";
import { Tooltip } from "@blueprintjs/core";
import { Position } from "@blueprintjs/core";
import "./UsersPerformanceViewTable.css";

const PerformanceTableInfoCard = ({ card, fullTitle = false }) => {
  const {
    title,
    total,
    completed = 0,
    notCompleted = 0
  } = card;

  const MAX_TITLE_LENGTH = 18;

  const truncatedTitle =
    title && title.length > MAX_TITLE_LENGTH
      ? `${title.substring(0, MAX_TITLE_LENGTH)}...`
      : title;

  const displayTitle = fullTitle ? title : truncatedTitle;
  const showTooltip = (fullTitle && title && title.length > 25) || (!fullTitle && title && title.length > MAX_TITLE_LENGTH);

  return (
    <div className={`performance-summary-card${fullTitle ? ' performance-summary-card--full-title' : ''}`}>

      {/* Title */}
      <div className="performance-summary-card-title">
        {showTooltip ? (
          <Tooltip portalContainer={document.body} content={title} position="top" hoverOpenDelay={100} boundary="viewport" className="custom-bp-tooltip" popoverClassName="custom-tooltip-width">
            <span>{displayTitle}</span>
          </Tooltip>
        ) : (
          displayTitle
        )}
      </div>

      {/* Stats */}
      <div className="performance-summary-card-stats">

        <span className="performance-summary-card-completed">
          {completed}
        </span>

        <span className="performance-summary-card-separator">
          /
        </span>

        <span className="performance-summary-card-pending">
          {notCompleted}
        </span>

      </div>

      {/* Labels */}
      <div className="performance-summary-card-label">
        <span>Done</span>
        <span>Pending</span>
      </div>

    </div>
  );
};

export default PerformanceTableInfoCard;